import React, { FC } from "react";
import { Grid } from "@mui/material";
import { useGridSharedStyles } from "./GridShared.style";
import { GridProps } from "@mui/material/Grid/Grid";

export const VGridContainer: FC<GridProps> = (props) => {
    const classes = useGridSharedStyles();
    const { children, ...rest } = props;
    return (
        <Grid container {...rest} className={classes.container}>
            {children}
        </Grid>
    );
};
